import { type QuestionTypeOption } from './dynamicDTOs';

export const questionTypes1: QuestionTypeOption[] = [
    {
        id: 1,
        key: 'numberForms',
        name: 'Number Forms',
        params: [
            {
                name: 'minNumber',
                displayName: 'Min Number',
                type: 'number',
                min: 0,
                max: 1000000,
                default: 0,
            },
            {
                name: 'maxNumber',
                displayName: 'Max Number',
                type: 'number',
                min: 0,
                max: 1000000,
                default: 999,
            },
        ],
        subTypes: [
            {
                id: 1,
                name: 'Expanded',
            },
            {
                id: 2,
                name: 'Standard',
            },
            {
                id: 3,
                name: 'Word',
            },
        ],
    },
    {
        id: 2,
        key: 'numberCompare',
        name: 'Number Compare',
        params: [
            {
                name: 'leftMin',
                displayName: 'Left Min',
                type: 'number',
                min: -2000000000,
                max: 2000000000,
                default: -100,
            },
            {
                name: 'leftMax',
                displayName: 'Left Max',
                type: 'number',
                min: -2000000000,
                max: 2000000000,
                default: 100,
            },
            {
                name: 'leftIncrement',
                displayName: 'Left Increment',
                type: 'number',
                min: 0.00000000001,
                max: 2000000000,
                default: 1,
                increment: 0.00000000001,
                helpText: 'For example, if set to 10, numbers will be rounded to 10',
            },
            {
                name: 'leftDisplayModes',
                displayName: 'Left Display Modes',
                type: 'multiSelect',
                required: true,
                options: [
                    { id: 1, name: 'Standard' },
                    { id: 2, name: 'Expanded' },
                    { id: 3, name: 'Word Form' },
                    { id: 4, name: 'Scientific' },
                ],
            },
            {
                name: 'rightMin',
                displayName: 'Right Min',
                type: 'number',
                min: -2000000000,
                max: 2000000000,
                default: -100,
            },
            {
                name: 'rightMax',
                displayName: 'Right Max',
                type: 'number',
                min: -2000000000,
                max: 2000000000,
                default: 100,
            },
            {
                name: 'rightIncrement',
                displayName: 'Right Increment',
                type: 'number',
                min: 0.00000000001,
                max: 2000000000,
                default: 1,
                increment: 0.00000000001,
                helpText: 'For example, if set to 10, numbers will be rounded to 10',
            },
            {
                name: 'rightDisplayModes',
                displayName: 'Right Display Modes',
                type: 'multiSelect',
                required: true,
                options: [
                    { id: 1, name: 'Standard' },
                    { id: 2, name: 'Expanded' },
                    { id: 3, name: 'Word Form' },
                    { id: 4, name: 'Scientific' },
                ],
            },
            {
                name: 'answerWeightLessThan',
                displayName: 'Answer Weight (Less Than)',
                type: 'number',
                min: 0,
                max: 100,
                default: 1,
                helpText:
                    'Weighted value that determines the frequency of answers. Higher numbers occur more often, and 0 never occurs.',
            },
            {
                name: 'answerWeightGreaterThan',
                displayName: 'Answer Weight (Greater Than)',
                type: 'number',
                min: 0,
                max: 100,
                default: 1,
                helpText:
                    'Weighted value that determines the frequency of answers. Higher numbers occur more often, and 0 never occurs.',
            },
            {
                name: 'answerWeightEqualTo',
                displayName: 'Answer Weight (Equal To)',
                type: 'number',
                min: 0,
                max: 100,
                default: 1,
                helpText:
                    'Weighted value that determines the frequency of answers. Higher numbers occur more often, and 0 never occurs.',
            },
        ],
    },
    {
        id: 3,
        key: 'tensHundreds',
        name: 'Tens & Hundreds',
        params: [
            {
                name: 'minTens',
                displayName: 'Min Tens',
                type: 'number',
                min: 10,
                max: 1000000,
                default: 10,
            },
            {
                name: 'maxTens',
                displayName: 'Max Tens',
                type: 'number',
                min: 10,
                max: 1000000,
                default: 100,
            },
            {
                name: 'mode',
                displayName: 'Mode',
                type: 'select',
                options: [
                    { id: 0, name: 'Random' },
                    { id: 1, name: 'Tens' },
                    { id: 2, name: 'Hundreds' },
                ],
            },
        ],
    },
    {
        id: 4,
        key: 'hundredsOnes',
        name: 'Hundreds & Ones',
        params: [
            {
                name: 'minOnes',
                displayName: 'Min Ones',
                type: 'number',
                min: 100,
                max: 1000000,
                default: 100,
            },
            {
                name: 'maxOnes',
                displayName: 'Max Ones',
                type: 'number',
                min: 100,
                max: 1000000,
                default: 1000,
            },
            {
                name: 'mode',
                displayName: 'Mode',
                type: 'select',
                options: [
                    { id: 1, name: 'Random' },
                    { id: 2, name: 'Ones' },
                    { id: 3, name: 'Hundreds' },
                ],
            },
        ],
    },
    {
        id: 5,
        key: 'twoStepWordProblem',
        name: 'Two-Step Word Problem',
        params: [
            {
                name: 'initialValueMin',
                displayName: 'Initial Minimum Value',
                type: 'number',
                min: 1,
                max: 1000000,
                default: 25,
            },
            {
                name: 'initialValueMax',
                displayName: 'Initial Maximum Value',
                type: 'number',
                min: 1,
                max: 1000000,
                default: 50,
            },
            {
                name: 'answerMin',
                displayName: 'Answer Minimum',
                type: 'number',
                min: 0,
                max: 1000000,
                default: 1,
            },
            {
                name: 'answerMax',
                displayName: 'Answer Maximum',
                type: 'number',
                min: 0,
                max: 1000000,
                default: 100,
            },
        ],
        subTypes: [
            {
                id: 1,
                name: 'Add',
                params: [
                    {
                        name: 'addMin',
                        displayName: 'Add Minimum',
                        type: 'number',
                        min: 1,
                        max: 1000000,
                        default: 1,
                    },
                    {
                        name: 'addMax',
                        displayName: 'Add Maximum',
                        type: 'number',
                        min: 1,
                        max: 1000000,
                        default: 10,
                    },
                ],
            },
            {
                id: 2,
                name: 'Subtract',
                params: [
                    {
                        name: 'subMin',
                        displayName: 'Subtract Minimum',
                        type: 'number',
                        min: 1,
                        max: 1000000,
                        default: 1,
                    },
                    {
                        name: 'subMax',
                        displayName: 'Subtract Maximum',
                        type: 'number',
                        min: 1,
                        max: 1000000,
                        default: 10,
                    },
                ],
            },
            {
                id: 3,
                name: 'Mixed',
                params: [
                    {
                        name: 'addMin',
                        displayName: 'Add Minimum',
                        type: 'number',
                        min: 1,
                        max: 1000000,
                        default: 1,
                    },
                    {
                        name: 'addMax',
                        displayName: 'Add Maximum',
                        type: 'number',
                        min: 1,
                        max: 1000000,
                        default: 10,
                    },
                    {
                        name: 'subMin',
                        displayName: 'Subtract Minimum',
                        type: 'number',
                        min: 1,
                        max: 1000000,
                        default: 1,
                    },
                    {
                        name: 'subMax',
                        displayName: 'Subtract Maximum',
                        type: 'number',
                        min: 1,
                        max: 1000000,
                        default: 10,
                    },
                ],
            },
        ],
    },
    {
        id: 6,
        key: 'moreLess',
        name: 'More/Less',
        params: [
            {
                name: 'baseMin',
                displayName: 'Base Min',
                type: 'number',
                min: 0,
                max: 1000000,
                default: 100,
            },
            {
                name: 'baseMax',
                displayName: 'Base Max',
                type: 'number',
                min: 0,
                max: 1000000,
                default: 1000,
            },
            {
                name: 'answerMin',
                displayName: 'Answer Min',
                type: 'number',
                min: 0,
                max: 1000000,
                default: 0,
            },
            {
                name: 'answerMax',
                displayName: 'Answer Max',
                type: 'number',
                min: 0,
                max: 1000000,
                default: 1000,
            },
        ],
        subTypes: [
            {
                id: 1,
                name: 'More Than',
                params: [
                    {
                        name: 'amountToAdd',
                        displayName: 'Amount To Add',
                        type: 'number',
                        min: 1,
                        max: 1000000,
                        default: 10,
                    },
                ],
            },
            {
                id: 2,
                name: 'Less Than',
                params: [
                    {
                        name: 'amountToSubtract',
                        displayName: 'Amount To Subtract',
                        type: 'number',
                        min: 1,
                        max: 1000000,
                        default: 10,
                    },
                ],
            },
        ],
    },
    {
        id: 7,
        key: 'lengthMeasurementTools',
        name: 'Length Measurement Tools',
    },
    {
        id: 8,
        key: 'measurementWordProblem',
        name: 'Measurement Word Problem',
        params: [
            {
                name: 'measure1Min',
                displayName: 'Measure 1 Min',
                type: 'number',
                min: 1,
                max: 1000000,
                default: 21,
            },
            {
                name: 'measure1Max',
                displayName: 'Measure 1 Max',
                type: 'number',
                min: 1,
                max: 1000000,
                default: 40,
            },
            {
                name: 'measure2Min',
                displayName: 'Measure 2 Min',
                type: 'number',
                min: 1,
                max: 1000000,
                default: 1,
            },
            {
                name: 'measure2Max',
                displayName: 'Measure 2 Max',
                type: 'number',
                min: 1,
                max: 1000000,
                default: 20,
            },
            {
                name: 'answerMin',
                displayName: 'Answer Min',
                type: 'number',
                min: 0,
                max: 1000000,
                default: 1,
            },
            {
                name: 'answerMax',
                displayName: 'Answer Max',
                type: 'number',
                min: 0,
                max: 1000000,
                default: 100,
            },
        ],
        subTypes: [
            {
                id: 1,
                name: 'Add',
            },
            {
                id: 2,
                name: 'Subtract',
            },
        ],
    },
];
